import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import DashboardHeader from "../layout/DashboardHeader";

const AdminLayout = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const handleSidebarToggle = (collapsed) => {
    setIsSidebarCollapsed(collapsed);
  };

  const handleMobileSidebarToggle = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      if (!mobile) {
        // On desktop, ensure mobile sidebar is closed
        setIsMobileSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Set initial value

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="min-h-screen bg-secondary-50">
      {/* Desktop Sidebar - Always visible on desktop */}
      <div className="hidden lg:block">
        <AdminSidebar 
          onToggle={handleSidebarToggle} 
          isMobile={false}
          isSidebarCollapsed={isSidebarCollapsed}
          isMobileSidebarOpen={false}
          onMobileSidebarToggle={() => {}}
        />
      </div>

      {/* Mobile Sidebar - Only when open on mobile */}
      {isMobile && (
        <AdminSidebar 
          onToggle={handleSidebarToggle} 
          isMobile={true}
          isSidebarCollapsed={false}
          isMobileSidebarOpen={isMobileSidebarOpen}
          onMobileSidebarToggle={handleMobileSidebarToggle}
        />
      )}
      
      {/* Main content area */}
      <div className={`min-h-screen transition-all duration-300 ${
        isMobile ? 'lg:ml-0' : isSidebarCollapsed ? 'lg:ml-16' : 'lg:ml-64'
      }`}>
        <DashboardHeader 
          isSidebarCollapsed={isSidebarCollapsed}
          onMobileMenuToggle={handleMobileSidebarToggle}
          isMobile={isMobile}
        />
        <main className="py-4 px-4 min-h-screen">
          <div className="p-4 md:p-6">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Mobile sidebar backdrop */}
      {isMobile && isMobileSidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={handleMobileSidebarToggle}
        />
      )}
    </div>
  );
};

export default AdminLayout;